import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, Scale } from 'lucide-react';

type Props = {
  grievanceId: string;
  className?: string;
  layout?: 'row' | 'stack';
};

export const GrievancePolicyLinks: React.FC<Props> = ({
  grievanceId,
  className = '',
  layout = 'row',
}) => {
  const navigate = useNavigate();
  const base = `/grievances/${encodeURIComponent(grievanceId)}/policy`;
  const flexClass = layout === 'stack' ? 'flex flex-col gap-2' : 'flex flex-wrap gap-2';

  return (
    <div className={`${flexClass} ${className}`}>
      <button
        type="button"
        onClick={() => navigate(`${base}/vendor`)}
        className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-gray-300 px-3 py-2 text-sm font-medium text-gray-800 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-100 dark:hover:bg-gray-700"
      >
        <FileText className="h-4 w-4 shrink-0" />
        View vendor policy
      </button>
      <button
        type="button"
        onClick={() => navigate(`${base}/user`)}
        className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-gray-300 px-3 py-2 text-sm font-medium text-gray-800 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-100 dark:hover:bg-gray-700"
      >
        <Scale className="h-4 w-4 shrink-0" />
        View user policy
      </button>
    </div>
  );
};
